import React from 'react'
import Button from '@material-ui/core/Button';

import ButtonContent from './ButtonContent'

const SaveOrCancel = ({saveDisabled, onSaveClick, cancelDisabled, onCancelClick}) => {
  return (
    <div style={{display: 'flex', width: 180, justifyContent: 'space-between', alignItems: 'center'}}>
      <Button
        disabled={saveDisabled}
        onClick={onSaveClick}
        variant="contained"
        color="primary">
        <ButtonContent
          text="Save"
          icon="chevron-right"/>
      </Button>
      <div>or</div>
      <Button
        disabled={cancelDisabled}
        onClick={onCancelClick}>
      Cancel
      </Button>
    </div>
  )
}

export default SaveOrCancel



// WEBPACK FOOTER //
// ./src/components/SaveOrCancel.js